"use client";

import CustomImage from '@/components/image';
import styles from './_consider.module.scss';
import Button from '@/components/button';
import HcpDrQuote from '@/components-hcp/dr-quote';

export default function HcpClinicalInformationConsider({index = 0}) {
  return (
    <section className={styles.consider}>
      <div className="container">
        <div className={styles.content}>
          <h2 className={styles.consider__heading}>
            Consider how CRENESSITY could<br className={styles.desktopBreak} /> help 
            patients reach their treatment goals{index === 0 && <sup>1,9</sup>}{index === 1 && <sup>1,10</sup>}
          </h2>
          <div className={styles.consider__info}>
            <p>Explore the impact of CRENESSITY across multiple 
            CAH treatment goals—jump to sections aligned with each goal and its corresponding clinical outcomes by using the <span className="text-nowrap">links below.</span></p>
            <CustomImage
              src={`${index === 0 ? "/images/page/hcp/clinical-information/child-and-adult.svg" : "/images/page/hcp/clinical-information/Clinical-Information_Adult-Trial-Icon.svg"}`}
              width={120}
              height={136}
            />
          </div>

          <div className={styles.consider__nav_container}>
            <nav className={`${styles.consider__nav} ${styles.consider__nav__greater}`}>
              <div className={styles.consider__nav_header}>
                <span>Patients with<br className={styles.mobileBreak}/> androstenedione levels <strong className="text-nowrap">&gt;ULN</strong></span>
              </div>
              <div className={styles.consider__nav_links}>
                <div className={styles.consider__nav_links_item}>
                  <Button
                    type="button"
                    data-gtm-event-category="Action"
                    data-gtm-event-action="Click"
                    data-gtm-event-label="Reduce  androgens"
                    onClick={(e) => {
                      window.location.hash = '';
                      window.location.hash = index === 0
                        ? 'trial-1-efficacy-androstenedione'
                        : 'trial-2-efficacy-androstenedione';
                    }}
                  ><u>Reduce androgens</u>
                  </Button>
                </div>
                <div className={styles.consider__nav_links_item}>
                  <Button
                    type="button"
                    onClick={(e) => {
                      window.location.hash = '';
                      window.location.hash = index === 0
                        ? 'trial-1-efficacy-dose-reductions'
                        : 'trial-2-efficacy-dose-reductions';
                    }}
                    data-gtm-event-category="Action"
                    data-gtm-event-action="Click"
                    data-gtm-event-label="Reduce high GC doses"
                  ><span><u>Reduce high GC doses</u>*</span>
                  </Button>
                </div>
                <div className={styles.consider__nav_links_item}>
                  <Button
                    type="button"
                    onClick={(e) => {
                      window.location.hash = '';
                      window.location.hash = index === 0
                        ? 'trial-1-efficacy-reduced-gc'
                        : 'trial-2-efficacy-majority';
                    }}
                    data-gtm-event-category="Action"
                    data-gtm-event-action="Click"
                    data-gtm-event-label="Reduce androgens and reduce high GC doses"
                  ><span><u>Reduce androgens and <br />reduce high GC doses</u>*</span>
                  </Button>
                </div>
              </div>
            </nav>

            <nav className={`${styles.consider__nav} ${styles.consider__nav__lesser}`}>
              <div className={styles.consider__nav_header}>
                <span>Patients with<br className={styles.mobileBreak}/> androstenedione<br className={styles.desktopBreak}/> levels <strong className="text-nowrap">&le;ULN</strong></span>
              </div>
              <div className={styles.consider__nav_links}>
                <div className={styles.consider__nav_links_item}>
                  <Button
                    type="button"
                    onClick={(e) => {
                      window.location.hash = '';
                      window.location.hash = index === 0
                        ? 'trial-1-efficacy-reduced-gc'
                        : 'trial-2-efficacy-majority';
                    }}
                    data-gtm-event-category="Action"
                    data-gtm-event-action="Click"
                    data-gtm-event-label="Maintain androgens and reduce high GC doses"
                  ><span><u>Maintain androgens and<br/>reduce high GC doses</u>*</span>
                  </Button>
                </div>
              </div>
            </nav>
          </div>

          <div className={styles.consider__footnote}>
            {index === 0 && <span>In the CAHtalyst<sup>&reg;</sup> clinical trials, high GC doses were defined as &gt;11 mg/m<sup>2</sup>/day in hydrocortisone equivalents, based on an equivalency factor of 4 times for prednisolone and prednisone.</span>}
            {index === 1 && <span>In the CAHtalyst<sup>&reg;</sup> clinical trials, high GC doses were defined as &gt;20 mg/day in hydrocortisone equivalents, based on an equivalency factor of 4 times for methylprednisolone, prednisolone, and prednisone and 60 times for dexamethasone and body surface area of 1.84 m<sup>2</sup>.<sup>8,10</sup></span>}
          </div>
        </div>
      </div>
      <HcpDrQuote
        doctor={{
          name: 'Dr. Heidi Shea',
          specialty: 'Adult & Pediatric Endocrinologist',
          image: '/images/components/CAH-HCP-Specialist-Dr-Shea.png',
          note: 'Compensated by Neurocrine for sharing her views.'
        }}
      >
        It’s allowing us to realign our goals with treatment. By adding<br className={styles.desktopBreak}/> CRENESSITY, the goal is to lower the glucocorticoid dose.”
      </HcpDrQuote>
    </section>
  );
}
